import { useCallback, useEffect, useState } from 'react';
import to_top_img from '../../../../assets/media/icons/top.png';
import Icon from '../../Elements/Icon';
import Button from '../Button';
import styles from './styles.module.scss';

const ToTopButton = () => {
  const [isShow, setShow] = useState(false);

  const scroll = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const scrollCheck = useCallback(() => {
    if ((document.documentElement.scrollTop || document.body.scrollTop) > 100) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', scrollCheck);

    return () => window.removeEventListener('scroll', scrollCheck);
  }, []);

  return (
    <Button className={isShow ? styles.top_button : styles.top_button_Hide} onClick={scroll}>
      <Icon src={to_top_img} width={40} height={40} />
    </Button>
  );
};

export default ToTopButton;
